// extracted by mini-css-extract-plugin
module.exports = {"page":"_11437"};